<template>
  <div v-show="config.show" class="my-container index">
    <div v-if="!isDesktop && config.showHead" class="header my-header">
      <div class="left">
        &nbsp;
      </div>
      <div class="middle">
        <img v-if="state.env === 'pro'" src="@/assets/logo.png" :title="$t('siteName')">
        <img v-if="state.env !== 'pro'" src="@/assets/logo-s-en.png" :title="$t('siteName')">
      </div>
      <div class="right" />
    </div>
    <pull-to :id="'index-container'" :ref="'index-container'" :style="style" :top-load-method="(loaded) => renewView(loaded)" :bottom-load-method="(loaded) => getData(loaded)" @infinite-scroll="getData()">
      <!-- <aipost
        ref="aipost"
        mod="aipost"
        :view="view"
        :state="state"
        :login-status="loginStatus"
        :login-user-id="loginUserId"
        @receive="handle"
      /> -->
      <el-carousel ref="swipeAds" v-finger:swipe="onSwipeAd" :interval="8000" arrow="hover" class="bg-22" @change="calcSwipeAdBgStyle">
        <div :style="swipeAdBgStyle" />
        <el-carousel-item v-for="(swipeAd, idx) in swipeAds" :key="idx" height="300" :style="swipeAdStyle(swipeAd)">
          <div style="width:100%; height:100%;" @click="linkTo(swipeAd.link)">
            <div class="title ellipsis color-ee">{{ swipeAd.tag + ' | ' + swipeAd.title }}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="bg-1b margin-top8 align-center">
        <el-row>
          <el-col :span="isDesktop ? 4 : 8">
            <div class="btn-col" @click="goto('aiart')">
              <span class="iconfont my-aigc size24 box40" /><div class="margin-top8 size12">{{ $t('i.start_aigc') }}</div>
            </div>
          </el-col>
          <el-col :span="isDesktop ? 4 : 8">
            <div class="btn-col" @click="emit('openVoxel')">
              <span class="iconfont my-vox size24 box40" /><div class="margin-top8 size12">{{ $t('i.voxEditer') }}</div>
            </div>
          </el-col>
          <el-col :span="isDesktop ? 4 : 8">
            <div class="btn-col" @click="emit('openEditer')">
              <span class="iconfont my-gridsfy size24 box40" /><div class="margin-top8 size12">{{ $t('i.createPixel') }}</div>
            </div>
          </el-col>
          <el-col :span="isDesktop ? 4 : 8">
            <div class="btn-col" @click="openPopPage({ 'type': 'toBrickfy' })">
              <span class="iconfont my-avatar size24 box40" /><div class="margin-top8 size12">{{ $t('i.createPixelPuzzle') }}</div>
            </div>
          </el-col>
          <el-col :span="isDesktop ? 4 : 8">
            <div class="btn-col" @click="emit('openPost')">
              <span class="iconfont my-post-add size24 box40" /><div class="margin-top8 size12">{{ $t('i.addPost') }}</div>
            </div>
          </el-col>
          <!-- <el-col :span="isDesktop ? 4 : 8">
            <div class="btn-col" @click="openPopPage({ 'type': 'toBeadsPixel' })">
              <span class="iconfont my-bean size24 box40" /><div class="margin-top8 size12">{{ $t('i.aiBeadsPixel') }}</div>
            </div>
          </el-col> -->
          <el-col :span="isDesktop ? 4 : 8">
            <div class="btn-col">
              <el-dropdown trigger="click" placement="bottom-start" @command="(cmd) =>emit('openMyPublish', [cmd])">
                <div><span class="iconfont my-plus size24 box40" /><div class="margin-top8 size12 color-ff">{{ $t('i.publish') }}...</div></div>
                <el-dropdown-menu slot="dropdown" class="my-dropdown">
                  <el-dropdown-item v-for="(workClass, idx) in workClasses" v-show="workClass.quick_add" :key="idx" :command="workClass.type" :icon="workClass.icon" class="iconfont">{{ $t('i.publish') }} {{ workClass.label }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="my-row bg-22 margin-top10 padding-top12 round-top4">
        <el-row>
          <el-col :span="8"><b>{{ $t('i.type_vox') }}</b></el-col>
          <el-col :span="16" class="right">
            <el-button class="tap-btn box24" @click="emit('gotoWorks', [5, 'best', 1])">
              <i class="iconfont my-right" />
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="my-content">
        <works-item
          v-show="config.show"
          ref="voxel-index"
          mod="index"
          :view="view"
          :state="state"
          :params="{ classid: 5 }"
          :login-status="loginStatus"
          :login-user-id="loginUserId"
          :page-size="6"
          @receive="handle"
        />
      </div>
      <!-- <div class="my-row bg-22 margin-top10 padding-top12 round-top4">
        <el-row>
          <el-col :span="8"><b>{{ $t('i.type_chain_brick') }}</b></el-col>
          <el-col :span="16" class="right">
            <el-button class="tap-btn box24" @click="emit('gotoWorks', [5, 'best', 1])">
              <i class="iconfont my-right" />
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="my-content">
        <works-item
          v-show="config.show"
          ref="chain_brick-index"
          mod="index"
          :view="view"
          :state="state"
          :params="{ classid: 5 }"
          :login-status="loginStatus"
          :login-user-id="loginUserId"
          :page-size="6"
          @receive="handle"
        />
      </div> -->
      <div class="my-row bg-22 margin-top10 padding-top12 round-top4">
        <el-row>
          <el-col :span="8"><b>{{ $t('i.pixel') }}</b></el-col>
          <el-col :span="16" class="right">
            <el-button class="tap-btn box24" @click="emit('gotoWorks', [2, 'best', 1])">
              <i class="iconfont my-right" />
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="my-content">
        <works-item
          v-show="config.show"
          ref="brickfy-index"
          mod="index"
          :view="view"
          :state="state"
          :params="{ classid: 2 }"
          :login-status="loginStatus"
          :login-user-id="loginUserId"
          :page-size="6"
          @receive="handle"
        />
      </div>
      <div class="my-row bg-22 margin-top10 padding-top12 round-top4">
        <el-row>
          <el-col :span="8"><b>{{ $t('i.gridy') }}</b></el-col>
          <el-col :span="16" class="right">
            <el-button class="tap-btn box24" @click="emit('gotoWorks', [0, 'best', 1])">
              <i class="iconfont my-right" />
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="my-content">
        <works-item
          v-show="config.show"
          ref="works-index"
          mod="index"
          :view="view"
          :state="state"
          :params="{ classid: 0 }"
          :login-status="loginStatus"
          :login-user-id="loginUserId"
          :page-size="6"
          @receive="handle"
        />
      </div>
      <div class="my-row bg-22 margin-top10 padding-top12 round-top4">
        <el-row>
          <el-col :span="8"><b>{{ $t('i.pixelPuzzle') }}</b></el-col>
          <el-col :span="16" class="right">
            <el-button class="tap-btn box24" @click="emit('gotoWorks', [1, 'best', 1])">
              <i class="iconfont my-right" />
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="my-content">
        <works-item
          v-show="config.show"
          ref="puzzle-index"
          mod="index"
          :view="view"
          :state="state"
          :params="{ classid: 1 }"
          :login-status="loginStatus"
          :login-user-id="loginUserId"
          :page-size="6"
          @receive="handle"
        />
      </div>
      <!--
      <div class="my-row bg-22 margin-top10 padding-top12 round-top4">
        <el-row>
          <el-col :span="8"><b>{{ $t('i.type_d3s') }}</b></el-col>
          <el-col :span="16" class="right">
            <el-button class="tap-btn box24" @click="emit('gotoWorks', [3, 'best', 1])">
              <i class="iconfont my-right" />
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="my-content">
        <works-item
          v-show="config.show"
          ref="d3-index"
          mod="index"
          :view="view"
          :state="state"
          :params="{ classid: 3 }"
          :login-status="loginStatus"
          :login-user-id="loginUserId"
          :page-size="6"
          @receive="handle"
        />
      </div>
      <div class="my-row bg-22 margin-top10 padding-top12 round-top4">
        <el-row>
          <el-col :span="8"><b>{{ $t('i.ip_imgs') }}</b></el-col>
          <el-col :span="16" class="right">
            <el-button class="tap-btn box24" @click="emit('gotoWorks', [7, 'best', 1])">
              <i class="iconfont my-right" />
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="my-content">
        <works-item
          v-show="config.show"
          ref="views-index"
          mod="index"
          :view="view"
          :state="state"
          :params="{ classid: 7 }"
          :login-status="loginStatus"
          :login-user-id="loginUserId"
          :page-size="6"
          @receive="handle"
        />
      </div>
      <div class="my-row bg-22 margin-top8">
        <el-row>
          <el-col :span="8"><b>{{ $t('i.album') }}</b></el-col>
          <el-col :span="16" class="right">
            <el-button class="tap-btn box24" @click="goto('album', { type: 'best' })">
              <i class="iconfont my-right" />
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="my-content round-bottom4">
        <album-item
          v-show="config.show"
          ref="album-index"
          mod="index"
          :view="view"
          :state="state"
          :login-status="loginStatus"
          :login-user-id="loginUserId"
          :page-size="6"
          @receive="handle"
        />
      </div>
      <div class="my-row bg-22 round4 margin-top8">
        <el-row>
          <el-col :span="8" class="padding-top4"><b>{{ $t('i.aiart') }}</b></el-col>
          <el-col :span="16" class="right">
            <el-button class="tap-btn box24" @click="goto('aiart')">
              <i class="iconfont my-right" />
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div class="my-content">
        <aiart-item
          v-show="config.show"
          ref="aiart-index"
          mod="index"
          :view="view"
          :state="state"
          :login-status="loginStatus"
          :login-user-id="loginUserId"
          :page-size="6"
          @receive="handle"
        />
      </div>
      <div v-if="showIdx > 0 || scrollTop > 50" class="my-row bg-22 margin-top10 round4">
        <el-row>
          <el-col :span="8" class="padding-top4"><b>{{ $t('i.nft') }}</b></el-col>
          <el-col :span="16" class="right">
            <el-button class="tap-btn box24" @click="goto('nft', { type: 'publish' })">
              <i class="iconfont my-right" />
            </el-button>
          </el-col>
        </el-row>
      </div>
      <nft-item
        v-if="showIdx > 0 || scrollTop > 50"
        v-show="config.show"
        ref="nft-index"
        mod="index"
        :view="view"
        :state="state"
        :login-status="loginStatus"
        :login-user-id="loginUserId"
        :page-size="isMobile ? 1: 4"
        @receive="handle"
      />
      <div v-if="showIdx > 1 || scrollTop > 150" class="active-users round4">
        <div class="my-row bg-22 round4">
          <el-row>
            <el-col :span="8"><b>{{ $t('i.creator') }}</b></el-col>
            <el-col :span="16" class="right">
              <el-button class="tap-btn box24" @click="goto('users', { type: 'new' })">
                <i class="iconfont my-right" />
              </el-button>
            </el-col>
          </el-row>
        </div>
        <creator-item
          v-if="showIdx > 1 || scrollTop > 150"
          v-show="config.show"
          ref="users-index"
          mod="index"
          :view="view"
          :state="state"
          :login-status="loginStatus"
          :login-user-id="loginUserId"
          :page-size="isMobile ? 5: 8"
          @receive="handle"
        />
      </div>
      <div class="my-row bg-22 margin-top10 round4">
        <el-row>
          <el-col :span="8" class="padding-top4"><b>{{ $t('i.zone') }}</b></el-col>
          <el-col :span="16" class="right">
            <el-button class="tap-btn box24" @click="goto('zone', { type: 'new' })">
              <i class="iconfont my-right" />
            </el-button>
          </el-col>
        </el-row>
      </div>
      <thread-item
        v-show="config.show"
        ref="thread-index"
        mod="index"
        :view="view"
        :state="state"
        :login-status="loginStatus"
        :login-user-id="loginUserId"
        :max-page="3"
        @receive="handle"
      /> -->
      <div class="my-row margin12 bg-22 align-center size12 color-55" style="padding: 30px 0;">
        <div class="size12 color-55 margin-bottom12">{{ $t('copyRight') }}</div>
      </div>
    </pull-to>
    <div v-if="scrollTop > 200" class="go-top">
      <el-button class="tap-btn" @click="backTop()">
        <i class="iconfont my-top" />
      </el-button>
    </div>
  </div>
</template>
<script>
import PullTo from 'vue-pull-to'
// import aipost from '@/components/web/aipost'
// import aiartItem from '@/components/web/aiartItem'
// import nftItem from '@/components/web/nftItem'
import worksItem from '@/components/web/worksItem'
// import threadItem from '@/components/web/threadItem'
// import creatorItem from '@/components/web/creatorItem'
// import albumItem from '@/components/web/albumItem'
import { mixins } from '@/mixins/common'
import service from '@/js/service'
import utils from '@/js/utils'
import conf from '@/js/conf/conf'
export default {
  components: {
    // aipost,
    // aiartItem,
    // nftItem,
    // threadItem,
    // creatorItem,
    // albumItem,
    PullTo,
    worksItem
  },
  mixins: [mixins],
  data() {
    const data = {}
    data.workClasses = conf.workClasses()
    data.swipeAds = []
    data.swipeAdBgStyle = {}
    data.scrollTop = 0
    data.showIdx = 0
    return data
  },
  computed: {
    isDesktop() {
      return this.state.platform.type === 'desktop'
    },
    style() {
      if (this.isDesktop) {
        return { 'width': '100%', 'height': 'calc(100% - ' + (this.config.showHead ? 50 : 10) + 'px)' }
      }
      return { 'width': '100%', 'height': 'calc(100% - ' + (this.config.showHead ? 90 : 50) + 'px)' }
    },
    config() {
      return this.view.index
    }
  },
  watch: {
    'view.index.show': {
      handler() {
        if (this.view.index.show && !this.swipeAds.length) this.getSwipeAd()
      }
    }
  },
  mounted() {
    this.initScroll()
  },
  methods: {
    initScroll() {
      const container = this.scrollContainer()
      if (container) {
        container.onscroll = () => { this.scrollTop = container.scrollTop }
      } else {
        setTimeout(this.initScroll, 100)
      }
    },
    scrollContainer() {
      const main = document.getElementById('index-container')
      if (main) {
        const scroll = main.getElementsByClassName('scroll-container')
        if (scroll.length) return scroll[0]
      }
    },
    backTop() {
      const container = this.scrollContainer()
      if (container) {
        setTimeout(() => {
          container.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
        }, 100)
      }
    },
    calcSwipeAdBgStyle(i) {
      const item = this.swipeAds[i]
      if (!item) {
        this.swipeAdBgStyle = {}
        return
      }
      const bg = this.getSwipeAdBackground(item)
      const style = {}
      if (bg) {
        style['position'] = 'absolute'
        style['width'] = '100%'
        style['height'] = '300px'
        style['background-image'] = 'url(' + bg + ')'
        style['background-position'] = 'center center'
        style['opacity'] = '0.3'
        style['filter'] = 'blur(3px)'
        style['-webkit-mask'] = '-webkit-linear-gradient(#ffffff, transparent)'
      }
      this.swipeAdBgStyle = style
    },
    swipeAdStyle(item) {
      const style = {}
      const bg = this.getSwipeAdBackground(item)
      if (bg) {
        style['background-image'] = 'url(' + bg + ')'
        style['background-position'] = 'center center'
        style['background-size'] = 'auto 100%'
        style['background-repeat'] = 'no-repeat'
      }
      return style
    },
    getSwipeAdBackground(item) {
      const ver = item.swipeid + '_' + item.update_at
      if (item.image) return service.getCosUrl(item.image, 'swipe_ad', ver) || ''
    },
    renewView(loaded) {
      this.callSub('brickfy-index', 'renewView')
      this.callSub('voxel-index', 'renewView')
      this.callSub('d3-index', 'renewView')
      this.callSub('pixel-index', 'renewView')
      this.callSub('works-index', 'renewView')
      this.callSub('puzzle-index', 'renewView')
      this.callSub('chain_brick-index', 'renewView')
      this.callSub('views-index', 'renewView')
      // this.callSub('users-index', 'renewView')
      // this.callSub('thread-index', 'renewView')
      // this.callSub('album-index', 'renewView')
      this.getSwipeAd(loaded)
      this.backTop()
    },
    callSub(ref, fn) {
      const el = this.$refs[ref]
      if (el && el[fn]) {
        el[fn]()
      } else {
        setTimeout(() => {
          this.callSub(ref, fn)
        }, 100)
      }
    },
    handle(act, data) {
      if (act === 'setLockSwipe') {
        // console.log('TODO....setLockSwipe')
      } else {
        this.emit(act, data)
      }
    },
    getData(loaded) {
      this.showIdx++
      // this.callSub('thread-index', 'getData')
      if (loaded) loaded('done')
    },
    getSwipeAd(loaded) {
      service.listGet('swipe', { sort_field: 'ordernum', sort: 'desc', simple: 1, limit: 5 }, (dt, type) => {
        if (type === 'success') {
          this.swipeAds = dt.data.items
          this.calcSwipeAdBgStyle(0)
          this.update()
        }
        loaded && loaded('done')
      })
    },
    linkTo(link) {
      if (utils.isUrl(link)) {
        window.open(link)
      } else {
        link = utils.jsonParse(link)
        if (link.mod) this.emit('goto', [link.mod, link.dt || {}])
      }
    },
    onSwipeAd(e) {
      if (e.direction === 'Left') {
        this.$refs['swipeAds'].prev()
      } else if (e.direction === 'Right') {
        this.$refs['swipeAds'].next()
      }
    }
  }
}
</script>
